import PartnersShow from "../components/partners/Show";

export default [
  { name: 'Partners', path: '/partners', component: PartnersShow,  }
]
